import { TextArea } from "@rawa/ui/TextArea"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the text as typed, or none once it is emptied.
export const multilineText: ControlRenderer<"multilineText"> = {
  Render: ({ field, value, onChange, error }) => (
    <TextArea
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value ?? ""}
      onChange={(text) => onChange(text === "" ? undefined : text)}
      placeholder={field.placeholder}
      required={field.required}
      error={error}
    />
  ),
}
